import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsSchemesProjectRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-permissions-associate',
	path: '/secure/project/SelectProjectPermissionScheme!default.jspa',
};
